import { useState, useEffect } from 'react'

export function useCountdown() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59,
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prev) => {
        if (prev.seconds > 0)
          return {
            ...prev,
            seconds: prev.seconds - 1,
          }
        if (prev.minutes > 0)
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59,
          }
        if (prev.hours > 0)
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59,
          }
        return prev
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return time
}
